/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Printer16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray50}
            fillRule="evenodd"
            d="M11 10a1 1 0 011 1v3a1 1 0 01-1 1H5a1 1 0 01-1-1v-3a1 1 0 011-1h6zm-.5 3h-5c-.3 0-.5.2-.5.5 0 .267.158.454.404.493L5.5 14h5c.3 0 .5-.2.5-.5s-.2-.5-.5-.5zM13 4a2 2 0 012 2v4a2 2 0 01-2 2v-1a2 2 0 00-2-2H5a2 2 0 00-2 2v1a2 2 0 01-2-2V6a2 2 0 012-2h10zm-2.5 7h-5c-.3 0-.5.2-.5.5 0 .267.158.454.404.493L5.5 12h5c.3 0 .5-.2.5-.5s-.2-.5-.5-.5zm-6-5h-1c-.3 0-.5.2-.5.5 0 .267.158.454.404.493L3.5 7h1c.3 0 .5-.2.5-.5S4.8 6 4.5 6zM11 1a1 1 0 011 1v1H4V2a1 1 0 011-1h6z"
        />
    </AccessibleSVG>
);

export default Printer16;
